import { Table } from "react-bootstrap";
import dayjs from "dayjs";
import { useState,useEffect } from "react";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AddDmPromoCode from "./addDmPromoCode";
import { doc, getFirestore, setDoc } from "firebase/firestore";
import {FaTrash} from "react-icons/fa";





export default function MessageRequestPromos(props) {

    const db=getFirestore();

    var currentCelebDetails = props.currentCelebDetails;
    var currentCelebId = props.celebId;
    const [hide, setHide] = useState(false);
    
    

    return (
        <div className="h-[600px] w-full bg-white/20 flex justify-start items-start overflow-scroll flex-col">

            {hide == true ? <AddDmPromoCode onClose={()=>{setHide(false);}} id={currentCelebId} /> : ""}

            <div className="flex flex-row justify-center items-center gap-8 p-4">
                <div className="text-3xl font-bold">Message Request Promos</div>
                <button
                    onClick={() => {
                        setHide(!hide);

                    }}
                    className="bg-white text-black rounded-3xl pl-4 pr-4 pt-2 pb-2 shadow-2xl hover:scale-105">Add Promo</button>

            </div>


            <div className="p-4">
                <Table bordered className="text-white table-fixed w-full mt-8" >
                    <thead>
                        <td className="w-1/5">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Promo Title
                            </div>
                        </td>
                        <td className="w-1/5">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Promo Code
                            </div>
                        </td>
                        <td className="w-1/5">
                            <div className="p-1 h-15 flex justify-center items-center overflow-x-scroll">
                                Discount
                            </div>
                        </td>
                        <td className="w-1/5">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Total Codes
                            </div>
                        </td>
                        <td className="w-1/5">
                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                Expiry Date
                            </div>
                        </td>
                        <td className="w-1/5">
                        <div className="p-1 h-15 flex justify-center items-center overflow-x-scroll">
                                Delete
                            </div>
                        </td>
                    </thead>

                    <tbody>

                        {
                            currentCelebDetails["dm"] != undefined ? currentCelebDetails["dm"]["promos"].map((promo,index) => {
                                return (
                                    <tr>
                                        <td className="w-1/5">
                                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                                {promo["promoTitle"]}
                                            </div>
                                        </td>
                                        <td className="w-1/5">
                                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                                {promo["promoCode"]}
                                            </div>
                                        </td>
                                        <td className="w-1/5">
                                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                                {promo["promoDiscount"]}%
                                            </div>
                                        </td>
                                        <td className="w-1/5">
                                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                                {promo["totalPromoCodes"]}
                                            </div>
                                        </td>
                                        <td className="w-1/5">
                                            <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                                {dayjs(promo["expiry"].toDate()).toString()}
                                            </div>
                                        </td>
                                        <td className="w-1/5">
                                            <button 
                                            onClick={async()=>{
                                                await currentCelebDetails["dm"]["promos"].splice(index,1);
                                                setDoc(doc(db,"celebrities",currentCelebId),currentCelebDetails,{merge:true});
                                                setHide(false);
                                            }}
                                            className="p-1 h-15 w-full flex justify-center items-center overflow-x-scroll">
                                                <FaTrash size={25}/>
                                            </button>
                                        </td>
                                    </tr>

                                )
                            }) : ""
                        }

                    </tbody>

                </Table>
            </div>




        </div>
    )
}